package ui.home

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.BasicAlertDialog
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.VerticalDivider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import com.essntl.essntl_common.generated.resources.Res
import com.essntl.essntl_common.generated.resources.first_time_image
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.button.secondary.EsLargeSecondaryButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsSmallIcon
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import org.jetbrains.compose.resources.painterResource

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun FirstTimeDialog(
    openDialog: Boolean,
    onAddServices: () -> Unit,
    onDismissRequest: () -> Unit,
) {
    if (openDialog)
        BasicAlertDialog(
            onDismissRequest = onDismissRequest,
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth(0.8f)
                    .clip(RoundedCornerShape(25.dp))
                    .border(
                        width = 2.dp,
                        color = Color.White,
                        shape = RoundedCornerShape(25.dp),
                    )
                    .background(
                        color = Color.White,
                        shape = RoundedCornerShape(25.dp),
                    ),
            ) {
                Image(
                    painter = painterResource(Res.drawable.first_time_image),
                    contentDescription = "first_time_image",
                    contentScale = ContentScale.FillWidth,
                    modifier = Modifier.fillMaxWidth(),
                )

                Spacer(modifier = Modifier.height(1.5.spacing))

                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 3.spacing)
                        .padding(bottom = 2.spacing),
                ) {
                    Text(
                        text = "Welcome to Odia \uD83D\uDC4B",
                        style = MaterialTheme.esTypography.h3Bold24,
                        color = MaterialTheme.esColorScheme.textPrimary,
                    )

                    Spacer(modifier = Modifier.height(1.spacing))

                    Text(
                        text = "Welcome aboard! It’s great to have you with us. Start by creating services for your first proposal.",
                        color = MaterialTheme.esColorScheme.textTertiary,
                        style = MaterialTheme.esTypography.p1Regular16,
                    )

                    Spacer(modifier = Modifier.height(2.spacing))

                    Row(
                        verticalAlignment = Alignment.Top,
                    ) {
                        Column(
                            horizontalAlignment = Alignment.CenterHorizontally,
                        ) {
                            EsSmallIcon(
                                res = EsIcons.Service,
                            )

                            VerticalDivider(
                                thickness = 1.dp,
                                color = MaterialTheme.esColorScheme.primary,
                                modifier = Modifier
                                    .height(50.dp)
                                    .padding(vertical = 1.spacing),
                            )
                        }

                        Spacer(modifier = Modifier.width(1.5.spacing))

                        Column {
                            Text(
                                text = "Add Services",
                                style = MaterialTheme.esTypography.p1Regular16,
                            )

                            Text(
                                text = "Begin by adding Services to you app",
                                color = MaterialTheme.esColorScheme.textTertiary,
                                style = MaterialTheme.esTypography.p1Regular16,
                            )
                        }
                    }

                    Spacer(modifier = Modifier.height(1.spacing))

                    Row(
                        verticalAlignment = Alignment.Top,
                    ) {
                        Column(
                            horizontalAlignment = Alignment.CenterHorizontally,
                        ) {
                            EsSmallIcon(
                                res = EsIcons.Proposal,
                            )

                            VerticalDivider(
                                thickness = 1.dp,
                                color = MaterialTheme.esColorScheme.primary,
                                modifier = Modifier
                                    .height(50.dp)
                                    .padding(vertical = 1.spacing),
                            )
                        }

                        Spacer(modifier = Modifier.width(1.5.spacing))

                        Column {
                            Text(
                                text = "Create Proposal",
                                style = MaterialTheme.esTypography.p1Regular16,
                            )

                            Text(
                                text = "Create your first Proposal",
                                color = MaterialTheme.esColorScheme.textTertiary,
                                style = MaterialTheme.esTypography.p1Regular16,
                            )
                        }
                    }

                    Spacer(modifier = Modifier.height(1.spacing))

                    Row(
                        verticalAlignment = Alignment.Top,
                    ) {
                        EsSmallIcon(
                            res = EsIcons.Send,
                        )

                        Spacer(modifier = Modifier.width(1.5.spacing))

                        Column {
                            Text(
                                text = "Send Proposal",
                                style = MaterialTheme.esTypography.p1Regular16,
                            )

                            Text(
                                text = "Send your Proposal to your client",
                                color = MaterialTheme.esColorScheme.textTertiary,
                                style = MaterialTheme.esTypography.p1Regular16,
                            )
                        }
                    }

                    Spacer(modifier = Modifier.height(3.spacing))

                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.Center,
                        modifier = Modifier.fillMaxWidth(),
                    ) {
                        EsLargeSecondaryButton(
                            onClick = onDismissRequest,
                            text = "Close",
                            modifier = Modifier.weight(1f),
                        )

                        Spacer(modifier = Modifier.width(width = 1.5.spacing))

                        EsLargePrimaryButton(
                            onClick = {
                                onAddServices()
                                onDismissRequest()
                            },
                            text = "Add Services",
                            modifier = Modifier.weight(1f),
                        )
                    }
                }
            }
        }
}